import type { MigrationStrategies } from "./_types/migration-strategies";

export const EPOCUS_PROBE_ASSOCIATION_MIGRATION_STRATEGIES: MigrationStrategies =
  {
    1: (oldDoc) => ({ ...oldDoc, programId: null }),
    2: (oldDoc) => ({ ...oldDoc, deviceAeTitle: null }),
  };
